module.exports = __webpack_public_path__ + "19fa845255e69a898e63000deadc6d1f.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/head/party-hat.png
// module id = 2781
// module chunks = 0